import { LoginResult } from '@/redux/slices/sessionSlice'
import { useRouter } from 'expo-router'

type HandleLoginResultArgs = {
  router: ReturnType<typeof useRouter>
  loginResult: LoginResult
}

export default function handleLoginResult({ router, loginResult }: HandleLoginResultArgs) {
  if (router.canDismiss()) router.dismissAll()

  if (loginResult.length > 1) {
    router.replace('/login/switch_user')
  } else {
    router.replace('/forms')
  }
}
